<h1 mat-dialog-title>
    {{title}}
</h1>

<div mat-dialog-content style="height: calc(100% - 96px);">
    <span [innerHtml]="message"></span>
</div>

<div mat-dialog-actions>
    <span *ngIf="mode === modeOkCancel">
        <app-edit-view-actions [disabled]="false"
            [completeText]="'Ok'"
            [cancelText]="'Cancel'"
            (cancelled)="cancelled()"
            (completed)="completed()">
        </app-edit-view-actions>
    </span>
    <span *ngIf="mode === modeYesNo">
        <app-edit-view-actions [disabled]="false"
            [completeText]="'Yes'"
            [cancelText]="'No'"
            (cancelled)="cancelled()"
            (completed)="completed()">
        </app-edit-view-actions>
    </span>
    <span *ngIf="mode === modeOk">
        <app-edit-view-actions [disabled]="false"
            [completeText]="'Ok'"
            [hideCancelButton]="true"
            (completed)="completed()">
        </app-edit-view-actions>
    </span>
</div>
